import { IRootState } from '../../../store'
import { IPCRCrewMember } from '../store/crew.types'

export const getPCRCrewSelector = (state: IRootState): IPCRCrewMember[] => state.crew.pcrCrew
